module.exports = __webpack_public_path__ + "img/v2.3.6fcce21a.png";